var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup68(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 44,
    viewBox: "0 0 150 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f{fill:none;}.a{stroke:#fff;stroke-width:0.5px;}.b,.c,.d{fill:#fff;}.b{font-size:18px;}.b,.c{font-family:Roboto-Regular, Roboto;}.c{font-size:10px;}.e{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-60 -655)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(60 655)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 150,
    height: 44,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 0.25,
    y: 0.25,
    width: 149.5,
    height: 43.5,
    rx: 3.75
  })), /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(105 691)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "App Store")), /*#__PURE__*/React.createElement("text", {
    className: "c",
    transform: "translate(105 669)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Download on the")), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M20.722,17.624a6.064,6.064,0,0,1,3.248-5.508,6.979,6.979,0,0,0-5.5-2.9c-2.306-.182-4.826,1.345-5.748,1.345-.974,0-3.209-1.28-4.962-1.28C4.133,9.343.281,12.175.281,17.936a16.189,16.189,0,0,0,.935,5.274c.831,2.384,3.832,8.23,6.963,8.132C9.816,31.3,10.973,30.18,13.1,30.18c2.066,0,3.137,1.163,4.962,1.163,3.157-.045,5.872-5.359,6.664-7.749a6.439,6.439,0,0,1-4.008-5.969ZM17.046,6.959A6.118,6.118,0,0,0,18.6,2.25a6.887,6.887,0,0,0-4.41,2.267,6.214,6.214,0,0,0-1.663,4.67,5.455,5.455,0,0,0,4.514-2.228Z",
    transform: "translate(72.271 659.75)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup68);
export default __webpack_public_path__ + "static/media/Group 68.5c06c6d19597b3a812f000fcea7af1a1.svg";
export { ForwardRef as ReactComponent };